export default __webpack_public_path__ + "static/media/download-arrow.666306a9.svg";